import { buildHref } from "@softmax/web-addresses";
import { SiteFooterView } from "@softmax/web-ux/shell";
import { FeatureLink as Link } from "../../navigation/feature-link";
import { SignedInOnly } from "../signed-in-only";
import {
  aboutLinks,
  defaultBrowseLinks,
  legalLinks,
  productLinks,
  type SiteLink,
} from "../site-links";
import { publicLinks } from "@softmax/web-addresses/discovery";

const socialLinks = [
  {
    label: "Discord",
    href: publicLinks.discord,
    icon: "/home/footer-discord.svg",
  },
  { label: "X", href: publicLinks.x, icon: "/home/footer-x.svg" },
  {
    label: "GitHub",
    href: publicLinks.github,
    icon: "/home/footer-github.svg",
  },
  {
    label: "Email",
    href: publicLinks.contactEmailHref,
    icon: "/home/footer-envelope.svg",
  },
];

export function SiteFooter({
  browseItems = defaultBrowseLinks,
}: {
  readonly browseItems?: SiteLink[] | undefined;
}) {
  return (
    <SiteFooterView
      homeHref={buildHref({ name: "home" })}
      browseItems={browseItems}
      productItems={productLinks}
      aboutItems={aboutLinks}
      legalItems={legalLinks}
      socialItems={socialLinks}
      brand={{
        markSrc: "/home/footer-brandmark.svg",
        wordmarkSrc: "/home/footer-wordmark.png",
      }}
      renderLink={(props) => <Link {...props} />}
      renderSignedInOnly={(children) => <SignedInOnly>{children}</SignedInOnly>}
    />
  );
}
